const productDetailStyles = (theme) => ({
  container: {
    width: { xs: "89%", sm: "85%", md: "80%" },
    backgroundColor: theme?.palette?.customColor?.white || "#FFFFFF",
    padding: "20px",
    margin: "0 auto",
  },
  headerWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  editBtn: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  editText: {
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  backBtn: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    cursor: "pointer",
  },
  title: {
    fontFamily: "Lexend",
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  productInformation: {
    marginTop: "30px",
  },
  subHeading: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  productInformationData: {
    marginTop: "20px",
  },
  imageWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  productImage: {
    width: "78px",
    height: "78px",
    border: `1px solid ${theme?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
    position: "relative",
    overflow: "hidden",
    minWidth: { xs: "78px" },
    minHeight: { xs: "78px" },
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  imageTitle: {
    wordBreak: "break-all",
    fontFamily: "Lexend",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
    maxWidth: { xs: "160px" },
  },
  statusWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  statusTitle: {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 300,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.secondarySecond || "#999999",
  },
  statusValue: {
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  description: {
    marginTop: "20px",
  },
  descriptionTitle: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.secondarySecond || "#999999",
  },
  descriptionValue: {
    wordBreak: "break-all",
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  commonTitle: {
    marginTop: "20px",
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.secondarySecond || "#999999",
  },
  chipWrap: {
    marginTop: "10px",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  chip: {
    width: "fit-content",
    padding: "5px 10px",
    borderRadius: "0px",
    backgroundColor: theme?.palette?.customColor?.secondaryFirst || "#F5F5F5",
  },
  chipValue: {
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  boxWrap: {
    marginTop: "20px",
    width: "90%",
    padding: "20px",
    borderRadius: "0px",
    backgroundColor: theme?.palette?.customColor?.secondaryFirst || "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  textWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  textWrap2: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
  },
  commonTitle2: {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.placeholder || "#999999",
  },
  text: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  commonTitle3: {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.secondarySecond || "#999999",
  },
  commonValue3: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  commonValue4: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.secondarySecond || "#999999",
  },
  deleteBtnContainer: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  },
  deleteBtn: {
    padding: "10px 20px",
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    textTransform: "none",
    borderRadius: "0px",
    border: `1px solid ${theme?.palette?.customColor?.red || "#FF0000"}`,
    color: theme?.palette?.customColor?.red || "#FF0000",
  },
  colorBoxWrap: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
  },
  colorBox: {
    width: "14px",
    height: "14px",
  },
});

export default productDetailStyles;

